<script setup lang="ts">
import { onMounted } from 'vue';
import Icon from '@atoms/components/Icon.vue';
import Typography from '@atoms/components/Typography.vue';
import { loadIntercom } from '@elements/intercom.ts';

interface MenuLinkProps {
  link?: string,
  icon?: string,
  iconName?: string,
  hasIconStroke?: boolean,
  size?: 'small' | 'medium',
  notificationsCount?: number,
}

withDefaults(defineProps<MenuLinkProps>(), {
  size: 'medium',
  icon: undefined,
  notificationsCount: 0,
});

onMounted(() => {
  loadIntercom();
});
</script>

<template>
  <a
    class="menu-item menu-item--link"
    :class="[ `menu-item--${size}`, iconName ]"
    :href="link"
  >
    <div
      v-if="icon"
      class="menu-item__icon"
    >
      <Icon
        v-if="hasIconStroke"
        :svg="icon"
        :custom-class="iconName"
        height="24"
        width="24"
        fill="none"
        stroke="gray-darker"
      />
      <Icon
        v-else
        :svg="icon"
        :custom-class="iconName"
        height="24"
        width="24"
        fill="gray-darker"
      />

      <span
        v-if="notificationsCount"
        class="side-bar-menu__pin"
      />
    </div>

    <Typography variant="body">
      <slot />

      <template v-if="notificationsCount">
        ({{ notificationsCount }})
      </template>
    </Typography>
  </a>
</template>
